import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useVatStore } from '@/stores/vat';
    import { Checkbox } from '@/components/ui/form';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ToggleShowPreviousSubmissions',
  setup(__props) {

    const vatStore = useVatStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Checkbox), {
    id: "sendToCustomer",
    modelValue: _unref(vatStore).showPreviousSubmission,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(vatStore).showPreviousSubmission) = $event)),
    label: "vat.show_previous_submission"
  }, null, 8, ["modelValue"]))
}
}

})